<template>
    <div>
        <el-table :data="data" border default-expand-all ref="table">
            <slot name="pre"></slot>

            <el-table-column label="供应商" prop="tbdwname" fixed min-width="100"></el-table-column>
            <el-table-column label="投标文件" width="300">
                <template slot-scope="scope">
                    <el-button
                    type="text"
                    icon="el-icon-view"
                    @click="viewPdfHandler(scope.row)"
                    >
                        查看
                    </el-button>

                    <el-button
                    type="text"
                    icon="el-icon-download"
                    @click="downloadHandler(scope.row)"
                    >
                        下载
                    </el-button>

                    <el-button
                    type="text"
                    icon="el-icon-files"
                    @click="fileDisHandler(scope.row)"
                    >
                        附件
                    </el-button>
                </template>
            </el-table-column>

            <slot></slot>
        </el-table>

        <my-dialog v-model="dialogVisible" :title="dialogTitle">
            <my-table :data="tableData">
                <el-table-column label="文件名称（点击下载）" prop="filename">
                    <template slot-scope="scope">
                        <a  @click="downloadFileHandler(scope.row)">
                            {{scope.row.filename}}
                        </a>
        
                    </template>
                </el-table-column>
                <el-table-column label="文件类型" prop="ext"></el-table-column>
                <el-table-column label="文件大小" prop="size"></el-table-column>
            </my-table>
        </my-dialog>
    </div>
</template>

<script>

export default {
    components: { },
    props: {
        data: {
            type: Array,
            default: () => []
        }
    },
    data: () => ({
        tableData: [],

        dialogVisible: false,
        dialogTitle: ''
    }),
    methods: {
        downloadHandler(row) {
            window.open(row.pdfFile);
        },
        downloadFileHandler(row) {
            var src = `http://121.28.5.198:8088/hzbtenderagentzero/Zbdl/zgsc/xingtai/${row.href}`;
            window.open(src);
        },
        fileDisHandler(row) {

            this.$get(`${this.getGetters('bidUrl')}/Zbdl/zgsc/xingtai/filedis.json`, {
                bdcode: this.getQuery('bdcode'),
                tbdwcode: row.tbdwcode
            }, data => {
                this.tableData = data.flist || [];
                this.dialogTitle = `${data.tbdwname}-投标文件附件`;
                this.dialogVisible = true;
            });
        },
        viewPdfHandler(row) {
            var search = toSearch({
                url: row.pdfFile 
            });
            var src = `/static/pc/agency/project-flow/kai-biao/pdf/capdf.html${search}`;
            
            this.$emit('view', row.pdfFile);
            // window.open(src);
        },
        doLayout() {
            this.$refs.table.doLayout();
        }
    },
    created() {

    }
}
</script>

<style scoped lang="scss">

</style>
